import React from "react";
import Hero from "../components/Hero";
import AboutPreview from "../components/AboutPreview";
import WhoIHelp from "../components/WhoIHelp";
import ServicesOverview from "../components/ServicesOverview";
import WhyDifferent from "../components/WhyDifferent";
import Process from "../components/Process";
import GoogleReviews from "../components/GoogleReviews";
import FAQ from "../components/FAQ";
import ContactCTA from "../components/ContactCTA";

const HomePage = () => {
  return (
    <>
      <Hero />
      <WhoIHelp />
      <ServicesOverview />
      <WhyDifferent />
      <AboutPreview />
      <Process />
      <GoogleReviews />
      <FAQ />
      <ContactCTA />
    </>
  );
};

export default HomePage;
